import api from '@js/actions/api';

export const fetchRidePois = (rideId, filter = {}, options = {}, requestOptions = {}) => (
    api
        .get(`/api/v1/rides/${rideId}/points-of-interest`, {
            filter,
            ...options
        }, requestOptions)
);

// export const addRidePoi = (rideId, poiData, isData = false) => (
//     api
//         .post(`/api/v1/rides/${rideId}/points-of-interest`, poiData, isData)
// );

export const updateRidePoi = (rideId, poiId, poiData, isData = false) => (
    api
        .update(`/api/v1/rides/${rideId}/points-of-interest/${poiId}`, poiData, isData)
);

export const deleteRidePoi = (rideId, poiId) => (
    api
        .delete(`/api/v1/rides/${rideId}/points-of-interest/${poiId}`)
);

// export const fetchPlanPois = (filter = {}, options = {}, requestOptions = {}) => (
//     api
//         .get('/api/v1/points-of-interest', {
//             plan: true,
//             filter,
//             ...options
//         }, requestOptions)
// );

export const addPlanPoi = (poiData) => (
    api
        .post('/api/v1/plan/points-of-interest', poiData, true)
);

export const updatePlanPoi = (poiId, poiData, isData = true) => (
    api
        .update(`/api/v1/points-of-interest/${poiId}`, poiData, isData)
);

export const deletePlanPoi = (poiId) => (
    api
        .delete(`/api/v1/points-of-interest/${poiId}`)
);
